import React, { useState, useEffect } from "react";
import "./HeroSection.css";
import graficaBlanca from "../../../assets/images/grafica_cap.png";
import fondoSectionCinco from "../../../assets/images/fondo_section_cinco.png";
import intro from "../../../assets/images/15.png";
import { useAuth } from "../../../context/AuthContext";
import { Link } from "react-router-dom";

const HeroSection = ({ onOpenFaq }) => {
  const { user, membership, ensureMembership } = useAuth();
  const [, setIsFreePlan] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const evalStatus = (m) => {
      const status = m?.status || "";
      const isFree = String(status).toLowerCase() !== "active";

      if (!cancelled) {
        setIsFreePlan(isFree);
      }
    };

    if (membership) {
      evalStatus(membership);
    } else if (user?.email) {
      ensureMembership(user.email)
        .then(evalStatus)
        .catch((err) => {
          console.error("HeroSection ensureMembership error:", err);
        });
    }

    return () => {
      cancelled = true;
    };
  }, [user, membership, ensureMembership]);

  return (
    <main className="analytics-page">
      {/* SECTION 1 */}
      <section className="hero-section">
        <div className="hero-overlay" />

        {String(user?.role || "").toLowerCase() === "admin" && (
          <Link className="hero-management-link" to="/dashboards" aria-label="Open management dashboard">
            <span className="hero-management-icon" aria-hidden="true">⚙</span> Management <span aria-hidden="true">↗</span>
          </Link>
        )}
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-title__top">Welcome to</span>
            <span className="hero-title__bottom">Invescasa Analytics</span>
          </h1>

          <p className="hero-description hero-description--bold">
            Your intelligence hub for the Australian real estate market.
          </p>

          <p className="hero-description">
            Access up-to-date data, trends, and key insights to make informed investment decisions.
          </p>

          <div className="hero-tabs">
            <span>Market Cycles</span>
            <span>Real Estate Indicators</span>
            <span>Economic Indicators</span>
            <span>Top Suburbs</span>
          </div>
        </div>
      </section>

      {/* SECTION 2 */}
      <section className="intro-section">
        <div className="intro-section__image-wrap">
          <img
            className="intro-section__image"
            src={intro}
            alt="Invescasa analytics illustration"
          />
        </div>

        <div className="intro-section__content">
          <h2 className="intro-section__title">
            With Invescasa Analytics, you can:
          </h2>

          <ul className="intro-section__list">
            <li>Track price trends across cities and suburbs</li>
            <li>Evaluate investment opportunities using real data</li>
            <li>Compare markets and identify high-growth areas</li>
            <li>Understand supply and demand dynamics</li>
          </ul>

          <p className="intro-section__copy">
            All supported by reliable data and clear visualizations.
          </p>
        </div>
      </section>

      {/* VIDEO SECTION */}
      <section className="video-section">
        <div className="video-section__frame">
          <iframe
            title="invescasa-video"
            src="https://player.cloudinary.com/embed/?cloud_name=dsvywoswv&public_id=VIDEO_tzwo23&profile=cld-default&autoplay=true&muted=true&loop=true&controls=false&hideContextMenu=true"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      </section>

      {/* SECTION 4 */}
      <section className="insights-section">
        <div className="insights-section__inner">
          <h2 className="insights-section__title">
            Why Data-Driven Investing Matters
          </h2>

          <div className="insights-section__body">
            <div className="insights-section__content">
              <p className="insights-section__lead">
                Informed decisions make the difference.
              </p>

              <p className="insights-section__sublead">
                Data-driven investing allows you to:
              </p>

              <ul className="insights-section__list">
                <li>Reduce uncertainty</li>
                <li>Identify high-potential markets</li>
                <li>Anticipate shifts in the property cycle</li>
                <li>Make strategic long-term decisions</li>
              </ul>

              <p className="insights-section__highlight">
                In a competitive market,
                <br />
                information is your greatest advantage.
              </p>
            </div>

            <div className="insights-section__visual">
              <div className="insights-section__chart-box">
                <img
                  src={graficaBlanca}
                  alt="Data-driven market chart"
                  className="insights-section__chart-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 */}
      <section className="ready-section">
        <div className="ready-section__inner">
          <img
            src={fondoSectionCinco}
            alt=""
            className="ready-section__background"
            aria-hidden="true"
          />

          <div className="ready-section__content">
            <h2 className="ready-section__title">Ready to invest?</h2>

            <p className="ready-section__copy">
              If you're ready to buy your first home or already investing, we
              can help you find the right opportunities to grow your wealth
              and make smarter property decisions.
            </p>

            <a
              href="https://www.invescasa.com.au/get-started"
              className="ready-section__cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book a call
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <div className="faq-cta">
        <h3 className="faq-cta__title">Need more information?</h3>

        <p className="faq-cta__text">
          Ready to move from analysis to acquisition? Book a private consultation.
          This is your chance to discuss real-time indicators and secure expert
          guidance, ensuring your next move in the Australian property market is
          your best move.
        </p>

        <div className="faq-cta__actions">
          <a
            href="https://www.invescasa.com.au/get-started"
            className="faq-cta__button faq-cta__button--primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Let’s talk
          </a>

          <button
            type="button"
            className="faq-cta__button faq-cta__button--secondary"
            onClick={onOpenFaq}
          >
            Frequently asked questions
          </button>
        </div>
      </div>
    </main>
  );
};

export default HeroSection;